import { component } from "picoapp";
import SubscriptionDropdown from "../lib/subscription-dropdown";
import $ from 'quantdom'
import { getBuyBoxVariant, getProduct } from '../lib/utils'

export default component( async (node) => {
  const handle = $(node).attr('data-handle')
  const productData = getProduct(handle)
  const product = await productData
  const currentVariant = getBuyBoxVariant(product)

  //hides selling plan options in the select element
  const variantGroupBlacklist = [
    {
      variantId: '46627410608296',
      hideSellingGroup: ['ac4e819d376f457226f56b5c1c61fcf8ea1d121d', '616d80d4ff5c6bce130c8604922b612c0b1a8437'],
    },
    {
      variantId: '46627410575528',
      hideSellingGroup: ['ac4e819d376f457226f56b5c1c61fcf8ea1d121d', '616d80d4ff5c6bce130c8604922b612c0b1a8437'],
    },

    {
      variantId: '46601533096104',
      hideSellingGroup: ['ac4e819d376f457226f56b5c1c61fcf8ea1d121d', '616d80d4ff5c6bce130c8604922b612c0b1a8437'],
    },
  ]
  new SubscriptionDropdown(
    { el: node, variantGroupBlacklist: variantGroupBlacklist, buyBoxProduct: product, buyBoxVariant: currentVariant },
    (e) => {
      const selectedText = $(e.target.options[e.target.selectedIndex])
        .text()
        .trim();

      $("[js-delivery-cadence]").each((el) => {
        el.innerHTML = selectedText;
      });

      $("[data-selling-plan-id]").attr(
        "data-selling-plan-id",
        e.selling_plan_id
      );
    }
  );
});
